import React from "react";

import {
  t,
  ITSMC_HEADING,
  ITSMC_P1,
  ITSMC_P2,
  ITSMC_P3,
  ITSMC_P4,
} from "../../translations/AboutUs/SutpIts";

function Itsmc() {
  return (
    <div class="main-container Itsmc">
      <div class="main-header">{t(ITSMC_HEADING)}</div>
      <div class="report-item-list">
        <ul>
          <li>{t(ITSMC_P1)}</li>
          <li
            style={{
              listStyleType: "none",
              backgroundColor: "#01aef0",
              color: "#ffffff",
              width: "20%",
            }}
          >
            {t(ITSMC_P2)}
          </li>
          <li>{t(ITSMC_P3)}</li>
          <li>{t(ITSMC_P4)}</li>
        </ul>
      </div>
    </div>
  );
}

export default Itsmc;
